<template>
  <div class="modal-manager">
    <stacked-modal
      v-for="(modal, index) in modalStack"
      :key="modal.id"
      :modal-index="index"
    >
      <!-- Render the appropriate modal content based on type -->
      <component
        :is="getModalComponent(modal.type)"
        :modal-data="modal.data"
        :modal-index="index"
        :is-footer-only="false"
      />

      <template v-slot:footer="{ modalData, modalType }">
        <!-- Render footer buttons -->
        <component
          :is="getModalComponent(modalType)"
          :modal-data="modalData"
          :modal-index="index"
          :is-footer-only="true"
        />
      </template>
    </stacked-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StackedModal from "./StackedModal.vue";
import ModalUser from "./modals/user/index.vue";
import ModalCompany from "./modals/company/index.vue";
import ModalProject from "./modals/project/index.vue";
import ModalCamera from "./modals/camera/index.vue";
import ModalContract from "./modals/contract/index.vue";
import ModalPayment from "./modals/payment/index.vue";
import ModalAddContract from "./modals/addContract/index.vue";
import ModalEditContract from "./modals/editContract/index.vue";
import ModalAddInvoice from "./modals/addInvoice/index.vue";
import ModalEditInvoice from "./modals/editInvoice/index.vue";
import ModalAddVideoOrder from "./modals/addVideoOrder/index.vue";
import ModalProCameraInventory from "./modals/proCameraInventory/index.vue";
import ModalAddProCameraInventory from "./modals/addProCameraInventory/index.vue";
import ModalComponent from "./modals/component/index.vue";

export default {
  name: "ModalManager",
  components: {
    ModalComponent,
    StackedModal,
    ModalUser,
    ModalCompany,
    ModalProject,
    ModalCamera,
    ModalContract,
    ModalPayment,
    ModalAddContract,
    ModalEditContract,
    ModalAddInvoice,
    ModalEditInvoice,
    ModalAddVideoOrder,
    ModalProCameraInventory,
    ModalAddProCameraInventory,
  },
  computed: {
    ...mapState(["modalStack"]),
  },
  methods: {
    getModalComponent(type) {
      const componentMap = {
        component: "ModalComponent",
        user: "ModalUser",
        company: "ModalCompany",
        project: "ModalProject",
        camera: "ModalCamera",
        contract: "ModalContract",
        payment: "ModalPayment",
        addContract: "ModalAddContract",
        editContract: "ModalEditContract",
        addInvoice: "ModalAddInvoice",
        editInvoice: "ModalEditInvoice",
        addVideoOrder: "ModalAddVideoOrder",
        proCameraInventory: "ModalProCameraInventory",
        addProCameraInventory: "ModalAddProCameraInventory",
      };
      return componentMap[type] || null;
    },
  },
};
</script>

<style scoped>
.modal-manager {
  position: relative;
}
</style>
